import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  
  /* added this function to fix the issue of Blog page updating URL to page 2 even if we have less than 1 page worth of posts */
  connectedCallback() {
    const lastPageAttr = this.getAttribute('last-page');
    const lastPage = lastPageAttr ? parseInt(lastPageAttr, 10) : 1;

    // Skip all pagination if only one page
    if (isNaN(lastPage) || lastPage <= 1) return;

    super.connectedCallback?.();
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
